import { getFacilitiesColumns } from '@/features/_columns/facilities-table-column'
import { DataTable } from '@/features/_components/data-table'
import { LoadingDataTable } from '@/features/_components/loading-data-table'
import { useCompanyContext } from '@/features/_contexts/company-context'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

interface FacilitiesTableProps {
  companyId: string
  search?: string
}

export const FacilitiesTable = ({ companyId, search }: FacilitiesTableProps) => {
  const company = useCompanyContext()
  const { data: facilities = [], isLoading } = useQuery(queries.companies.facilities(companyId))

  const columns = useMemo(() => getFacilitiesColumns(company?.slug ?? ''), [company?.slug])

  if (isLoading) return <LoadingDataTable columns={columns} />

  const filteredFacilities = facilities.filter((facility) =>
    facility.name.toLowerCase().includes((search ?? '').toLowerCase()),
  )

  return <DataTable columns={columns} data={filteredFacilities} />
}
